import React, { useState, useEffect } from 'react'; 
import Link from "next/link";
import Image from 'next/image';
import IMAGES from '@/public/assets/img';
import BrandCarousel from '@/component/shared/brandCarousel';
import AccordianFaq from '@/component/shared/accordianfaq';
import FormsPopups from '@/component/shared/formsPopups';
import { FORMSDATA } from '@/config/forms_config';
import SolutionBriefPopup from '@/component/shared/solutionBrief';
// import CaseStudyPopup from '@/component/shared/caseStudyPopup';
import Head from "next/head";
import { SEODATA } from '@/config/seo_config';
import AOS from 'aos';
import 'aos/dist/aos.css';
import TestimonialSlider from '@/component/shared/testimonialSlider';

const Customers={
    heading:'Our Happy Clients',
    paragraph: 'What they say about us',
    knowMoreCta: 'Know more',
    customersList:[
        {CustomerQuote:"We significantly improved our suppliers' cash cycle, allowing efficient invoice-to-cash processing", CustomerName:'Aditya Birla', CustomerDesignation:'Aditya Birla || Fashion & Retail', cta:'CredlixCasestudyAditya', src:IMAGES.HomeNew.adityaImg, },
        {CustomerQuote:'Their understanding and knowledge of financing solutions have been valuable for our business.',CustomerName:'Deepak Gaur Sharma', CustomerDesignation:'MD || Accord', cta:'CredlixCasestudyAccord', src:IMAGES.HomeNew.accordImg},
        {CustomerQuote:'Manufacturing company automates supply chain financing',CustomerName:'Ishita Bowry',CustomerDesignation:'Director - Finance ||TwigaFiber', cta:'CredlixCasestudyTwigafiber', src:IMAGES.HomeNew.twigaImg},
        {CustomerQuote:'The entire process of working with the Credlix team has been easy and end-to-end digital.',CustomerName:'Ujwal Desai',CustomerDesignation:'CEO & Founder || Lucro', cta:'CredlixCasestudyUjwal', src:IMAGES.HomeNew.lucroImg},
        {CustomerQuote:'Food processing company adds significant value to its supply chain',CustomerName:'Vinod Jobanputra',CustomerDesignation:'CEO & Founder || Lalsai Dehy Foods', cta:'CredlixCasestudyVinod', src:IMAGES.HomeNew.vinodImg},
    
      ]
  }

export const metadata = {
    title: SEODATA.ENTERPRISE.title,
    description: SEODATA.ENTERPRISE.description,
    alternates: {
      canonical: SEODATA.ENTERPRISE.url
    },
    
    openGraph: {
      title: SEODATA.ENTERPRISE.title,
      description: SEODATA.ENTERPRISE.description,
      url: SEODATA.ENTERPRISE.url,
    }
  };

const Enterprise = () =>{  
    const [mWidth, setMWidth] = useState(0)
    const handleWindowResize = () => {
      setMWidth(window.innerWidth);
    }
    const [show, setShow] = useState(false);
    // const [showCasestudy, setShowCasestudy] = useState(false);
    const [showSolution, setShowSolution] = useState(false);
    const [open, setOpen]= useState(false);
    const formSBType = 'DownloadSolutionEnterprise';
    const formType="RequestDemo";
    // const formCSType ='DownloadExporterCaseStudy';

    const toggle = (index) => {
        if(open === index){
          return setOpen(null)
        }
        setOpen(index)
      }
    const showModal = () => {
        setShow(true);
        handleRequestClick();
    }

    const showSolutionModal = () => {
        setShowSolution(true);
    }
    const handleOnClose =()=>{
        setShow(false);
    } 
    const handleOnCloseSolution =()=>{
        setShowSolution(false);
    } 
  
    useEffect(() => {
        AOS.init();
        handleWindowResize();
        window.addEventListener('load', handleWindowResize);
        // unsubscribe from the event on component unmount
        return () => window.removeEventListener('resize', handleWindowResize);
        // return () => clearTimeout(timeId);
      }, []);

//   useEffect(() => {
//     // const timeId = setTimeout(() => setShowCasestudy(true), 5000)
//     // return () => clearTimeout(timeId);
    
//   },[])

   
    const handleOnCloseCasestudy =()=>{
      clearTimeout(setShowCasestudy(false))
      // return () => clearTimeout(timeId);
    }
  const faqs =[
    {
      question:"Does Credlix lend money? Is it a Bank/NBFC?",
      answers:"No. Credlix is a supply chain finance technology platform that creates a single transaction view for distributors, suppliers, and lenders."
    },
    {
      question:"How many banks and NBFCs does Credlix have?",
      answers:"Credlix currently has 2 NBFCs and 3 Banks on the platform."
    },
    {
      question:"Can Credlix be integrated into existing systems for anchors?",
      answers:"Credlix is completely API driven and can embed into multiple customers or supplier journeys."
    }
    
  ]

  const handleConversion = () => {
    const conversionId = 'AW-11325447679/uX8RCPrflOAYEP-7spgq';
    window.gtag('event', 'conversion', {
      'send_to': conversionId,
    });
  };
    return(
        <main className='mt-[110px] sm:mt-[100px]'>

            <Head>  
                <title>{metadata.title}</title>
                <meta name="description" content={metadata.description} />
                {/* OpenGraph tags */} 
                <meta property="og:title" content={metadata.openGraph.title} />
                <meta property="og:description" content={metadata.openGraph.description} />
                <meta property="og:url" content={metadata.openGraph.url} />
                <link rel="canonical" href={metadata.alternates.canonical} />
                 <link rel="preload" as="image" href={IMAGES.ENTERPRISEIMG.bannerEnterprise.src}/>
            </Head>
                      
               <section style={{background:`url(${IMAGES.POFinance.bgBanner.src})`, backgroundSize:'cover', backgroundRepeat:'no-repeat'}}>
           <div className='container min-h-[470px] sm:pt-16 sm:min-h-[450px] flex h-full px-3 lg:px-3  xm:px-2'>
                        <div className='flex z-[1]  relative flex-wrap items-center'>
                                <div className='w-1/2 md:w-1/2 sm:w-full'>
                                    <div className='homebannertop'>
                                        <h1 className='text-base text-secondary font-medium mb-[5px]'>
                                            Credlix for Enterprises
                                            </h1>
                                            <h2 className='text-heading2 sm:text-xxl text-brand font-bold mb-3'>Your supply chain.<br/> Our financing solution.<br/> A winning partnership</h2>
                                        
                                        <p className='text-sm text-brand'>  Credlix lets you create better value for your partners. You can facilitate early payments solutions and vendor financing for your suppliers, and provide flexible channel finance solutions to your distributor network. 
                                        </p>
                                        <div className='flex flex-wrap sm:flex-col'>
                                            <Link onClick={handleConversion} href='https://app.credlix.com/#/auth/login' target="_blank" rel="noopener noreferrer" className='mt-5 sm:ml-0 text-center inline-block sm:w-[200px] bg-brand font-semibold border border-brand text-white text-sm py-[13px] sm:py-[15px]  px-[20px] rounded-xl bg-gradient-to-r from-[#022B5C] to-[#0363C4] shadow-md transition-all duration-300 ease-in-out hover:from-[#0363C4] hover:to-[#022B5C]'>
                                            Sign Up with Credlix 
                                            </Link>
                                            {mWidth >767 && 
                                            <Link href="#footersec" className="mt-5 sm:mt-3 items-center ml-1 sm:ml-0 bg-transparent sm:w-[190px] border border-brand justify-center font-semibold text-brand text-sm py-[13px] px-[20px] rounded-xl flex item-center"> Get Financed 
                                            <span className="align-middle ml-xsp"> <Image width={11} height={11} alt='Drop arrow' src={IMAGES.EARLYPAYMENTIMG.droparrow}/>
                                            </span>
                                            </Link>
                                            }
                                        </div>
                                        
                                    </div>
                                </div>
                                <div className='w-1/2 md:w-1/2 sm:w-full self-end'>
                                     <Image priority={true} fetchPriority='high' className='sm:mt-5 w-full h-full' src={IMAGES.ENTERPRISEIMG.bannerEnterprise} alt=" Credlix for Enterprises: Channel Finance" width={384} height={207} />
                                    
                                </div>
                            </div>
                        </div>
                
            </section>
            <section className='py-20 lg:py-sp-100'>
                <div className='container  lg:px-3  px-3 xm:px-2'>
                        <div className='heading-section'>
                            <h2 className='text-xxl text-secondary font-bold text-center mb-[35px]'>The Credlix Anchor Advantage</h2>
                            {/* <p className='text-base2 text-secondary text-center mt-1 mb-6'>Exporters plug into our solutions for enabling seamless cash flow into their business. We are an agile disruptor empowering businesses to innovate and streamline your supply chain operations.</p> */}
                        </div>
                        <div className='flex flex-wrap'>
                            <div className='icon-box w-1/3 sm:w-full sm:mb-6'>
                                <Image className='w-[110px] h-[110px] inline-block mx-auto' src={IMAGES.ENTERPRISEIMG.iuj} alt='Integerated User Journey'/>
                                <div className='text-left sm:px-0 px-3 pt-1'>
                                    <h4 className='text-base2 text-secondary font-bold mb-2'>Integerated User Journey</h4>
                                    <p className='text-base text-secondary font-normal'>End-to-end financing solutions for your supply chain partners from PO to Purchase to Sales- automated flows and transaction visibility</p>
                                </div>
                            </div>
                            <div className='icon-box w-1/3 sm:w-full sm:mb-6'>
                                <Image className='w-[110px] h-[110px] inline-block mx-auto' src={IMAGES.ENTERPRISEIMG.eoa} alt='Ease of Access'/>
                                <div className='text-left sm:px-0 px-3 pt-1'>
                                    <h4 className='text-base2 text-secondary font-bold mb-2'>Ease of Access</h4>
                                    <p className='text-base text-secondary font-normal'>Enable onboarding, document execution, and disbursements through one digital platform </p>
                                </div>
                            </div>
                            <div className='icon-box w-1/3 sm:w-full sm:mb-6'>
                                 <Image className='w-[110px] h-[110px] inline-block mx-auto' src={IMAGES.ENTERPRISEIMG.sdda}  alt='Superior Data-driven Analytics'/>
                                <div className='text-left sm:px-0 px-3 pt-1'>
                                    <h4 className='text-base2 text-secondary font-bold mb-2'>Superior Data-driven Analytics</h4>
                                    <p className='text-base text-secondary font-normal'>Access multiple dashboards and decision-making tools for greater visibility and control over your supply chain</p>
                                </div>
                            </div>
                        </div>
                </div>
            </section>
            <section id="explore_solution" className='bg-[#F1F0F6] py-20 lg:py-sp-100'>
                <div className='container px-3  lg:px-3  xm:px-2'>
                    <h2 className='text-xxl text-secondary font-bold mb-5 text-center'>
                        Explore Our Enterprise Solutions
                    </h2>
                <div className='flex flex-wrap mt-12 lg:-mx-5 md:-mx-2 sm:-mx-2 sm:flex-col'>
                        <div className='p-5 md:p-2 sm:p-2 w-1/3 md:w-1/3 sm:mb-3 sm:w-full'>
                                <Image className='m-auto' src={IMAGES.VENDORPAYMENTIMG.cardimg} alt="Early Payments"/>
                                <h3 className='text-lg text-secondary font-bold text-left pt-3 pb-1'>Early Payments</h3>
                                <p className='text-base text-secondary text-left lg:min-h-[70px] md:min-h-[163px]'>Unfold our early payment programs to support your supplier partners and generate desirable returns on cash.</p>
                                <a href="/enterprise/early-payment-discount" className='bg-gradient-to-r from-[#022B5C] to-[#0363C4] shadow-md transition-all duration-300 ease-in-out hover:from-[#0363C4] hover:to-[#022B5C] text-white text-sm w-[136px] h-[40px] flex items-center justify-center rounded-[10px] mt-5 cursor-pointer'>Learn More <span className='ml-1'><svg xmlns="https://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24"><path fill="none" d="M0 0h24v24H0z"/><path d="M16.172 11l-5.364-5.364 1.414-1.414L20 12l-7.778 7.778-1.414-1.414L16.172 13H4v-2z" fill="rgba(255,255,255,1)"/></svg></span></a>
                        </div>
                        <div className='p-5 md:p-2 sm:p-2 w-1/3 md:w-1/3 sm:mb-3 sm:w-full'>
                                <Image className='m-auto' src={IMAGES.EARLYPAYMENTIMG.cardimg} alt="Vendor Finance"/>
                                <h3 className='text-lg text-secondary font-bold text-left pt-3 pb-1'>Vendor Finance</h3>
                                <p className='text-base text-secondary text-left lg:min-h-[70px] md:min-h-[163px]'>Offer cash-flow-based lending solutions to your suppliers based on our digital authentication of their credit profiles.</p>
                                <a href='/enterprise/vendor-financing-india' className='bg-gradient-to-r from-[#022B5C] to-[#0363C4] shadow-md transition-all duration-300 ease-in-out hover:from-[#0363C4] hover:to-[#022B5C] text-white text-sm w-[136px] h-[40px] flex items-center justify-center rounded-[10px] mt-5 cursor-pointer '>Learn More <span className='ml-1'><svg xmlns="https://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24"><path fill="none" d="M0 0h24v24H0z"/><path d="M16.172 11l-5.364-5.364 1.414-1.414L20 12l-7.778 7.778-1.414-1.414L16.172 13H4v-2z" fill="rgba(255,255,255,1)"/></svg></span></a>
                        </div>
                        <div className='p-5 md:p-2 sm:p-2 w-1/3 md:w-1/3 sm:mb-3 sm:w-full'>
                                <Image className='m-auto' src={IMAGES.EARLYPAYMENTIMG.cardimgright} alt="Channel Finance"/>
                                <h3 className='text-lg text-secondary font-bold text-left pt-3 pb-1'>Channel Finance</h3>
                                <p className='text-base text-secondary text-left lg:min-h-[70px] md:min-h-[163px]'>Strengthen your connection with your distribution network and optimize your company's sales throughput and liquidity</p>
                                <a href='/enterprise/channel-financing-india' className='bg-gradient-to-r from-[#022B5C] to-[#0363C4] shadow-md transition-all duration-300 ease-in-out hover:from-[#0363C4] hover:to-[#022B5C] text-white text-sm w-[136px] h-[40px] flex items-center justify-center rounded-[10px] mt-5 cursor-pointer'>Learn More <span className='ml-1'><svg xmlns="https://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24"><path fill="none" d="M0 0h24v24H0z"/><path d="M16.172 11l-5.364-5.364 1.414-1.414L20 12l-7.778 7.778-1.414-1.414L16.172 13H4v-2z" fill="rgba(255,255,255,1)"/></svg></span></a>
                        </div>
                    </div>
                </div>
            </section>
            <section className='how-credlix py-20 bg-white sm:pb-0 lg:py-sp-100'>
                            <div className='container  lg:px-3  px-3 xm:px-2'>
                                <div>
                                    <h2 className='text-xxxl text-secondary font-bold text-left mb-6'>How Credlix Works for Exporters</h2>
                                </div>
                                <div className='flex items-center md:flex-col sm:flex-col'>
                                    <div className='w-1/2 md:w-full sm:w-full'>
                                        <div className='list-div'>
                                            <ul className='how-works-list-ent relative list-none p-0'>
                                                <li className='relative text-base2 text-secondary flex items-center leading-7 mb-6 pl-7 pr-4 pt-1'> Supplier invoices are uploaded to Credlix platform automatically by way of system integration with the Anchor or enterprise</li>
                                                <li className='relative text-base2 text-secondary flex items-center leading-7 mb-6 pl-7 pr-4 pt-1'> Credlix analytics engine auto approves and recommends invoices for early payment </li>
                                                <li className='relative text-base2 text-secondary flex items-center leading-7 mb-6 pl-7 pr-4 pt-1'>Supplier requests for early payment on Credlix </li>
                                                <li className='relative text-base2 text-secondary flex items-center leading-7 mb-6 pl-7 pr-4 pt-1'> Anchor or enterprise has choice to facilitate finance to suppliers using own funds or external lender </li>
                                                <li className='relative text-base2 text-secondary flex items-center leading-7 mb-6 pl-7 pr-4 pt-1'> Anchor or enterprise manages complete program on Credlix from supplier/distributor management to reconciliation through our smart dashboard</li>
                                            </ul>
                                        </div>
                                        <div className='flex items-center sm:flex-col sm:items-start'>
                                            <button onClick={showSolutionModal} className='mt-5 font-medium text-white text-sm py-1 px-2 rounded-xl sm:w-[250px] flex items-center justify-center sm:m-auto bg-gradient-to-r from-[#022B5C] to-[#0363C4] shadow-md transition-all duration-300 ease-in-out hover:from-[#0363C4] hover:to-[#022B5C]'>
                                            <span className='align-middle mr-[8px]'><svg xmlns="https://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24"><path fill="none" d="M0 0h24v24H0z"/><path d="M13 12h3l-4 4-4-4h3V8h2v4zm2-8H5v16h14V8h-4V4zM3 2.992C3 2.444 3.447 2 3.999 2H16l5 5v13.993A1 1 0 0 1 20.007 22H3.993A1 1 0 0 1 3 21.008V2.992z" fill="rgba(255,255,255,1)"/></svg></span>Download Solution Brief</button>
                                            <button onClick={showModal} className='mt-5 border-brand border sm:m-auto text-brand bg-white text-sm py-1 ml-3 font-medium sm:w-[250px] sm:mt-3 px-2 rounded-xl flex items-center justify-center'>Request Demo</button>
                                        </div>
                                    </div>
                                    <div className='w-1/2 md:w-full sm:w-full'>
                                        <div>
                                        {mWidth > 767 ? 
                                            <Image className='lg:w-[80%] m-auto' src={IMAGES.ENTERPRISEIMG.hcwfe} alt="How Credlix Works for Exporters"/>
                                        :
                                        <Image className='mt-5 m-auto' src={IMAGES.ENTERPRISEIMG.hcwfe_mb} alt="How Credlix Works for Exporters"/>
                                        }
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>
                        <div className='container px-3 py-20 lg:pb-sp-100 lg:pt-3'>
                         <TestimonialSlider content={Customers.customersList} interval={3000} />
                        </div>
            <div className='bg-[#F4F7FD]'>
                <BrandCarousel/>
            </div>
           
            <section className='bg-white py-20 grid place-items-center'>
                            <div className='container  lg:px-3 px-3 xm:px-2'>
                            <div>
                            <h3 className='text-xxxl text-secondary text-center font-bold mb-6'>Frequently Asked Questions</h3>
                            </div>
                            <div className="bg-white w-full text-left m-auto">
                                <div className="mx-auto  sm:w-auto">
                                  <AccordianFaq faqData={faqs} />
                                </div>      
                            </div>
                            </div>
             </section>
                   
            <FormsPopups formType={formType} onClose={handleOnClose} heading={FORMSDATA.SIGNUP_FOR_DEMO.requestdemo.heading} subheading={FORMSDATA.SIGNUP_FOR_DEMO.requestdemo.subheading} formimage={FORMSDATA.SIGNUP_FOR_DEMO.requestdemo.image} show={show} setShow={(bool) => setShow(bool)} />
            <SolutionBriefPopup formType={formSBType}  onClose={handleOnCloseSolution} heading={FORMSDATA.SOLUTION_BRIEF.downloadsolution.heading} subheading={FORMSDATA.SOLUTION_BRIEF.downloadsolution.subheading} formimage={FORMSDATA.SOLUTION_BRIEF.downloadsolution.image} show={showSolution} setShowSolution={(bool) => setShow(bool)} />
            {/* <CaseStudyPopup formCSType={formCSType} onClose={handleOnCloseCasestudy} heading={FORMSDATA.CASE_STUDY_POPUP.enterprise_download.heading} subheading={FORMSDATA.CASE_STUDY_POPUP.case_study_download.subheading} para={FORMSDATA.CASE_STUDY_POPUP.enterprise_download.para} formimage={FORMSDATA.CASE_STUDY_POPUP.enterprise_download.image} show={showCasestudy} /> */}
            <div className="md:visible lg:visible xm:visible" id="footersec"></div>
      </main>   
    );
    };
    
    export default Enterprise;